import {getToiletMgtData, getErrorToiletDevice} from '../../../api/adminDist/ToiletMgtApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  toilets: [],
  toiletErrorDevice: []
}

const getters = {
  getErrorToiletDevice: (state) => {
    return state.toiletErrorDevice
  },

  getScenicToilets: (state) => (condition = {}) => {
    if (Utils.isEmptyObject(condition) || condition[CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID] < 0) {
      return []
    }

    return state.toilets.filter(toilet => {
      return toilet[CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID] === condition[CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID]
    })

  },

  getOdorAlert(state){
    let isAlert = false
    for(let i = 0; i < state.toilets.length ; i++) {
      const toilets = state.toilets[i].toilets
      isAlert =toilets.every(t => {
        if(t.odor > CONST.ODOR_CRTICAL_POINT) {
          return true
        }

        return false
      })

      if(isAlert) {
        break
      }
    }

    return isAlert
  },

  getHandsanitizerAlert() {
    let isAlert = false
    for(let i = 0; i < state.toilets.length ; i++) {
      const toilets = state.toilets[i].toilets
      isAlert =toilets.every(t => {
        if(t.handsanitizerdetectors < CONST.HAND_SANITIZER_CRTICAL_POINT) {
          return true
        }

        return false
      })

      if(isAlert) {
        break
      }
    }

    return isAlert
  }
}

const actions = {
  async getToiletData({commit}, condition ={}) {
    const result = await getToiletMgtData(condition)
    if(result.success && !Utils.isEmptyObject(result.data)) {


      const data = {}
        data[CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID] = condition.id
        data[CONST.TOILET_MANAGEMENT_ITEM.PUBLIC_PLACE] = result.data[0].publicPlaceList;

      commit('toilets', {result: data, id: condition.id})
      // console.log(" getToiletData_result:data",data)
    }
  },

  async getMutiScenicToiletData({commit}, condition ={}) {
    const result = await getToiletMgtData(condition);
    // console.log("result",result)
    let data = {0:{}};
    data[0][CONST.TOILET_MANAGEMENT_ITEM.PUBLIC_PLACE] = [];
    data[0][CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID]=[];

    if(result.success && !Utils.isEmptyObject(result.data)){
      result.data.forEach((item) => {

        data[0][CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID].push(item.scenicAreaId)
        data[0][CONST.TOILET_MANAGEMENT_ITEM.PUBLIC_PLACE].push(...item.publicPlaceList);
      
      })

      return data;
      // console.log("data",data)

    }
  },

  async getTioletErrorDevice({commit}){
    const result = await getErrorToiletDevice()

    if(result.success) {
      commit('toiletsErrorDevice', result.body)
    }
  }

}

const mutations = {
  toilets(state, data) {
    

    let targetIndex  = state.toilets.findIndex(e => e[CONST.TOILET_MANAGEMENT_ITEM.SCENIC_AREA_ID] === data.id)
    if (targetIndex === -1) {
      state.toilets.push(data.result)
    } else {
      //要回傳新的 array 元素才會觸發 state 更新 
      // state.toilets[targetIndex] = data;
      state.toilets.splice(targetIndex, 1, data.result); 
      
    }
  },
  
  toiletsErrorDevice(state, data) {
    state.toiletErrorDevice = data
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}